import { render, staticRenderFns } from "./FeedbackTab.vue?vue&type=template&id=09c369c7&scoped=true&"
import script from "./FeedbackTab.vue?vue&type=script&lang=js&"
export * from "./FeedbackTab.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackTab.vue?vue&type=style&index=0&id=09c369c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c369c7",
  null
  
)

export default component.exports